module.exports = __webpack_public_path__ + "static/media/New-intro-nonword-BM.b1509f84.mp3";